import gsap, { Linear } from "gsap";

const partnersParade = () => {
    document.addEventListener("DOMContentLoaded", function () {
       
        const partnersContainer = document.getElementById('js-partners-container')
        if (partnersContainer) {

            const generatePartnersParade = () => {
                const partnersWrapper = document.getElementById('js-partners_wrapper')
                const partners = partnersWrapper.querySelectorAll('.partner-item');
                const clonedPartners = partnersWrapper.cloneNode(true)
                
                let partnersWidth = 0
    
                // Calcule of list width
                partners.forEach((partner) => {
                    let style = partner.currentSyle || window.getComputedStyle(partner);
                    let partnerGetWidth = partner.offsetWidth;
                    let partnerGetMargin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
     
                    let partnerWidth = partnerGetMargin + partnerGetWidth;
                    partnersWidth += partnerWidth;
                }) 
    
                // Cloning of list
                clonedPartners.classList.add('cloned')
                partnersContainer.append(clonedPartners);
    
                // Instance of timeline
                const InfiniteTimeline = gsap.timeline({repeat: -1});
    
                // Speed of list parade
                // The more the number is high, the more it is slow
                let speed = 40
    
    
                    InfiniteTimeline
                    .fromTo(
                        partners,
                      speed,
                      { rotation: 0.01, x: 0 },
                      { force3D: true, x: -partnersWidth, ease: Linear.easeNone },
                      0
                    )
                    .fromTo(
                        clonedPartners,
                      speed,
                      { rotation: 0.01, x: partnersWidth - 0 },
                      { force3D: true, x: 0, ease: Linear.easeNone },
                      0
                    )
                    .set(partners, { force3D: true, rotation: 0.01, x: partnersWidth })
                    .to(
                        clonedPartners,
                      speed,
                      { force3D: true, rotation: 0.01, x: -partnersWidth, ease: Linear.easeNone },
                      speed
                    )
                    .to(
                        partners,
                      speed,
                      { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone },
                      speed
                    )
          
                    .play()
            }
            generatePartnersParade()
        }
    })
};

export default partnersParade;